module.exports = __webpack_public_path__ + "static/media/varun.9499dac1.JPEG";